<ng-container *ngIf="(isFinishLoadingSubject | async) === false; else showContentTpl">
  <div *ngIf="type === 'text'">
    <ngx-skeleton-loader
      [count]=count
      [theme]="{ 'border-radius': '5', height: height + 'px', width: width + 'px' }"
    ></ngx-skeleton-loader>
  </div>
  <div *ngIf="type === 'icon'">
    <ngx-skeleton-loader
      [count]="count"
      appearance="circle"
      [theme]="{
      'width.px': 30,
      'height.px': 30,
      'border-radius': '5px'
    }"
    ></ngx-skeleton-loader>
  </div>
</ng-container>
<ng-template #showContentTpl>
  <ng-content></ng-content>
</ng-template>


